import { webCampaign } from '@/modules/webCampaign';

import { AI_DATA } from '../../constants';
import { OnboardingScreenInterests } from '../screens/Interests';

import { OnboardingReplikaAiCharacteristic } from './screens/AiCharacteristic';
import { OnboardingReplikaAppUsers } from './screens/AppUsers';
import { OnboardingReplikaChatExample } from './screens/ChatExample';
import { OnboardingReplikaChatVibe } from './screens/ChatVibe';
import { OnboardingReplikaEmail } from './screens/Email';
import { OnboardingReplikaLoneliness } from './screens/Loneliness';
import { ScreenLonelinessGraph } from './screens/LonelinessGraph';
import { OnboardingReplikaName } from './screens/Name';
import { OnboardingReplikaNoLimits } from './screens/NoLimits';
import { OnboardingReplikaPersonalizingFeed } from './screens/PersonalizingFeed';
import { ScreenPreferences } from './screens/Preferences';
import { OnboardingReplikaSecurity } from './screens/Security';
import { OnboardingReplikaTopics } from './screens/Topics';
import { LayoutDataType } from './types';

export const layoutSteps = {
  preferences: {
    component: ScreenPreferences,
    images: [],
  },
  no_limits: {
    component: OnboardingReplikaNoLimits,
    images: [AI_DATA[webCampaign.aiType].noLimit.bgImageSrc],
  },
  ai_characteristic: {
    component: OnboardingReplikaAiCharacteristic,
    images: [
      ...AI_DATA[webCampaign.aiType].characteristics.map(
        (data) => data.imageSrc,
      ),
    ],
  },
  interests: {
    component: OnboardingScreenInterests,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/svg-sprite.svg',
    ],
  },
  chat_vibe: {
    component: OnboardingReplikaChatVibe,
    images: [AI_DATA[webCampaign.aiType].chatVibe.bgImageSrc],
  },
  appusers: {
    component: OnboardingReplikaAppUsers,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/AppUsers/planet_static.png',
    ],
  },
  topics: {
    component: OnboardingReplikaTopics,
    images: [],
  },
  chat_example: {
    component: OnboardingReplikaChatExample,
    images: [AI_DATA[webCampaign.aiType].chat.imageSrc],
  },
  security: {
    component: OnboardingReplikaSecurity,
    images: [],
  },
  name: {
    component: OnboardingReplikaName,
    images: [],
  },
  loneliness: {
    component: OnboardingReplikaLoneliness,
    images: [],
  },
  loneliness_graph: {
    component: ScreenLonelinessGraph,
    images: [],
  },
  personalizing_feed: {
    component: OnboardingReplikaPersonalizingFeed,
    images: [],
  },
  email: {
    component: OnboardingReplikaEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  name: '',
  categories: [],
  preloadCategories: [],
  characters: [],
  ai_characteristic: 'Neutral',
  interests: [],
  topics: '',
  email: '',
  loneliness: null,
};

// Category constants - not used
// Categories are dynamically loaded from API via useQueryOnboardingCategories hook
// and sent to server on Preferences screen
export const HARDCODED_CATEGORIES = [];
